module.exports = __webpack_public_path__ + "media/images/logo/Logo-Moovejob-CMJN-fond-transparent-investisseur-f9e6073a9e4d8e809dd9ccca0dbaa26e.png";